// Elara performance/safety 2026-05-26: this asset loads globally; guard pages without the featured tab component.
const tabHeadingContainer = document.querySelector(".featured-collection-tab-title-block");
const tabHeading = document.querySelectorAll(".featured-collection-tab-title");
const tabCollection = document.querySelectorAll(".featured-collection-tab-product");

if (tabHeadingContainer && tabHeading.length && tabCollection.length) {
  tabHeadingContainer.addEventListener("click", function(e) {
    const clicked = e.target.closest(".featured-collection-tab-title");
    if (!clicked) return;
    tabHeading.forEach(tb => tb.classList.remove("active"));
    clicked.classList.add("active");
    tabCollection.forEach(tc => tc.classList.remove("active"));
    const target = document.querySelector(".featured-collection-tab-product--" + clicked.dataset.tab);
    if (target) target.classList.add("active");
  });
}
